var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "page-home" }, [
    _c(
      "section",
      {
        staticClass:
          "overview-section flex align_items__center justify_content__space_between"
      },
      [
        _c("div", { staticClass: "left-view flex align_items__center" }, [
          _vm._v(
            _vm._s(_vm.$t("欢迎回来，")) + _vm._s(_vm.userInfo.userName || "")
          )
        ]),
        _c("div", { staticClass: "right-view" }, [
          _vm._v(_vm._s(_vm.dateDesc()))
        ])
      ]
    ),
    _c("section", { staticClass: "panel-section" }, [
      _c("div", { staticClass: "panel-title section-stick" }, [
        _vm._v(_vm._s(_vm.$t("已订购产品")))
      ]),
      _c(
        "div",
        { staticClass: "flex flex_wrap__wrap" },
        _vm._l(_vm.purchaseList, function(item) {
          return _c(
            "div",
            {
              key: item.id,
              staticClass:
                "panel-item flex flex_direction__column align_items__center justify_content__center"
            },
            [
              item.icon
                ? _c("img", { attrs: { alt: "", src: item.icon } })
                : _vm._e(),
              _c("p", [_vm._v(_vm._s(item.projectCode))])
            ]
          )
        }),
        0
      )
    ]),
    _vm.pageLoading
      ? _c("div", {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.pageLoading,
              expression: "pageLoading"
            }
          ],
          staticClass: "loading-mask"
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }